import { KbCardPage } from "@/components/kb/KbCardPage";

export function Card009NicheDefinition() {
  return <KbCardPage slug="card-009-niche-definition" />;
}

(Card009NicheDefinition as unknown as { path: string }).path = "/methodology/009";
